import ShrinkVerticalIcon from '@atlaskit/icon/core/shrink-vertical';
import React from 'react';

export const SvgCollapseReplies = () => (
  <ShrinkVerticalIcon label="" testId="ads-refreshed-icon" />
);
